import React, { useState,useEffect } from 'react';


import HeaderMenuProfile from '../header/HeaderMenuProfile.js';


import Bet_history from './comm/bet_history.js';

import AccountSetting from './comm/account_setting.js';

import DepositAndWithdraw from './comm/deposit_withdraw.js';

import AuthService from '../../../class/services/AuthService';


import UserService from '../../../class/User/UserService';
import UserServices from '../../../class/User_copy/UserService';


import AccountNotification from './comm/account_notification.js';

import CashHistory from './comm/cash_history.js';

import Promotions from './comm/promotions.js';

const Profile = ({selection,selection_header_external, withdrawSection}) => {


  const [isLogged, setIsLogged] = useState(AuthService.isLogged());
  const [userId, setUserId] = useState(null);


  const [selection_header, setSelection_header] = useState('account_setting');

  


  useEffect(() => {

    setSelection_header(selection_header_external);

  }, [selection_header_external]); 
  
  
  
  useEffect(() => {
    const currentPath = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    const validPages = ['bet_history', 'account_setting', 'cash_movement', 'deposit_withdraw', 'notification'/* , 'promotions' */];
    
    if (validPages.includes(currentPath)) {
      setSelection_header(currentPath); // Якщо шлях коректний
    } 
  }, []);

  useEffect(() => {
    if (selection_header) {
      const currentPath = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
      if (currentPath !== selection_header) {
        window.history.replaceState({}, '', `/profile/${selection_header}`);
      }
    }
  }, [selection_header]);
  
  

  //ЗРОБИТИ ЩОБ ВСЕ БРАЛОСЯ З КОНФІГА game_slugs={['casino', 'casino-live', 'crash-game']} limit="2"  НА CMS

  return (

    <div className="container-fluid account-total-page">
      <div className="row">
        
        <HeaderMenuProfile  selection={selection_header}  setSelection_header={setSelection_header} withdrawSection={withdrawSection}  />

        {selection_header === 'bet_history' && <Bet_history />}

        {selection_header === 'account_setting' && <AccountSetting />}

        {selection_header === 'cash_movement' && <CashHistory AuthService={AuthService} UserServices={UserServices}  />}

        {/* {selection_header === 'deposit_withdraw' && <DepositAndWithdraw AuthService={AuthService} UserService={UserService} withdrawSection={withdrawSection} />} */}

        {/* {selection_header === 'notification' && <AccountNotification AuthService={AuthService} UserService={UserService}  />} */}

        {/* {selection_header === 'promotions' && <Promotions AuthService={AuthService} UserService={UserService}  />} */}

      </div>
    </div>
    
  );
};

export default Profile;
